import React from 'react'
import { list_skill_group } from '../utils/list_skill_group.util'

const Skill = ({
    skillRef,
    addSkillGroup,
    addSkill,
}) => {
    return (
        <div className="bg-[#FFFFFF] text-[#59595B] h-[70vw]"
            ref={skillRef}
            id={`skill`}
        >
            <div className="pt-[5vw] flex flex-col items-center w-[100vw] text-[2.5vh]">
                <div className="font-['Work_Sans'] font-bold text-[5vw] mb-[5vw] hover:text-[#E65445]">SKILLS</div>
                {
                    list_skill_group?.map((skill_group, index_skill_group) => {
                        return <>
                            <hr
                                ref={(el) => addSkillGroup({
                                    el
                                })}
                                className="border-t border-[#2B292A] w-[70vw]" />
                            <div className="flex h-[7vw]">
                                {
                                    skill_group?.map((skill, index_skill) => {
                                        return <>
                                            <div
                                                ref={(el) => addSkill({
                                                    el,
                                                    index_skill_group
                                                })}
                                                className="flex py-auto">
                                                <div className="my-auto hover:text-[#2B292A]">{skill?.name}</div>
                                                <div className=" hidden md:block rounded-full my-auto ">{" => "}<label className="text-[#E65445]">{`[ ${skill?.score} ]`}</label></div>
                                                {/* <div class="mr-[2vw] hidden md:block bg-[#FFFBEC] rounded-full h-[1vh] my-auto w-[16vw]">
                                                    <div class={`bg-[#56F09F] h-[1vh] rounded-full w-[${skill?.score}vw]`}></div>
                                                </div> */}
                                            </div>
                                            {
                                                skill_group?.length - 1 > index_skill && <div className="mr-[2vw]" />
                                            }
                                        </>
                                    })
                                }
                            </div>
                        </>
                    })
                }
                <hr className="border-t border-[#2B292A] w-[70vw]" />
            </div>
        </div>
    )
}

export default Skill